module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Medium.d815b0a.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat/Montserrat-Medium.otf
// module id = 1670
// module chunks = 4